"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_rc-tabs@9.1.10@rc-tabs/lib/KeyCode.js
// module id = 917
// module chunks = 0 1